import {
  REQUEST_INQUIRY_LIST,
  REQUEST_INQUIRY
} from './mutation-types'

import axiosInst from '@/utility/axiosInst'

export default {
  requestInquiryList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/inquiry/inquiry-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord: searchWord
      }
    }).then((res) => {
      commit(REQUEST_INQUIRY_LIST, res.data)
    })
  },

  requestInquiry({commit}, inquirySeq) {
    return axiosInst.springAxiosInst.get(`/admin/inquiry/inquiry/${inquirySeq}`)
    .then((res) => {
      commit(REQUEST_INQUIRY, res.data)
    })
  },

  requestAnswerInquiry({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/inquiry/answer-inquiry', payload)
      .then((res) => {
        return res.data
      })
  }
}